import { render } from "./ColorSelector.vue?vue&type=template&id=be623082&scoped=true"
import script from "./ColorSelector.vue?vue&type=script&lang=js"
export * from "./ColorSelector.vue?vue&type=script&lang=js"

import "./ColorSelector.vue?vue&type=style&index=0&id=be623082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be623082"]])

export default __exports__